import React from "react";
import styled from "styled-components";
import { InterNormalWhite22px } from "../../styledMixins";


function ListOfItems3(props) {
  const { listOfItems1, listOfItems2, listOfItems3, className } = props;

  return (
    <ListOfItems className={`list-of-items-25 ${className || ""}`}>
      <Text className="text-3"></Text>
      <ListOfItems1 className="list-of-items-26" src={listOfItems1} alt="List of Items" />
      <ListOfItems1 className="list-of-items-27" src={listOfItems2} alt="List of Items" />
      <ListOfItems1 className="list-of-items-28" src={listOfItems3} alt="List of Items" />
    </ListOfItems>
  );
}

const ListOfItems = styled.div`
  display: flex;
  margin-left: 6px;
  width: 268px;
  height: 171px;
  position: relative;
  margin-top: 12px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;

  &.list-of-items-25.list-of-items-29 {
    margin-left: 12px;
  }

  &.list-of-items-25.list-of-items-31 {
    margin-left: 12px;
  }
`;

const Text = styled.div`
  ${InterNormalWhite22px}
  position: relative;
  width: fit-content;
  margin-top: -1px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
`;

const ListOfItems1 = styled.img`
  position: relative;
  flex: 0 0 auto;
`;

export default ListOfItems3;
